(function () {

    'use strict';
    /* jshint newcap:false */

    angular
        .module('blocks.cache')
        .factory('cache', cache);

    cache.$inject = ['CacheFactory', '$rootScope'];

    function cache(CacheFactory, $rootScope) {
        function onExpire(key, value) {
            $rootScope.$emit('tokenExpired', value);
        };
        var __options = {
                maxAge: 780000, // 13 minutes
                storageMode: 'sessionStorage',
                deleteOnExpire: 'aggressive',
                storagePrefix: 'ecare-',
                onExpire: onExpire
            },
            localStore = create('LocalStore', { storageMode: 'localStorage' });

        // Return public API.
        return {
            create: create,
            setKey: setKey,
            getKey: getKey,
            getCollection: getCollection,
            destroy: destroy,
        };

        // ---
        // PUBLIC METHODS.
        // ---

        function create(key, options) {
            var cache,
                _optionsExtended = angular.copy(__options);

            angular.extend(_optionsExtended, options);
            if (getCollection(key)) { return getCollection(key); };

            return CacheFactory.createCache(key, _optionsExtended);
        }

        function setKey(collection, key, value) {
            if (!getCollection(collection)) {
                this.create(collection);
            }
            this.getCollection(collection).put(key, value);
        }

        function getCollection(collection) {
            return CacheFactory.get(collection);
        }

        function getKey(collection, key) {
            return getCollection(collection) && getCollection(collection).get(key);
        }

        function destroy(key) {
            return CacheFactory.get(key) && CacheFactory.get(key).destroy();
        }

        // ---
        // PRIVATE METHODS.
        // ---
    }

})();
